var _ellipse, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoMobile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 46,
    viewBox: "0 0 44 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 22.0055,
    cy: 22.5568,
    rx: 7.58755,
    ry: 7.77798,
    fill: "url(#paint0_linear_1629_57)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.0039 37.4877C30.0485 37.4877 36.5699 30.8026 36.5699 22.5562C36.5699 14.3097 30.0485 7.62461 22.0039 7.62461C13.9593 7.62461 7.43794 14.3097 7.43794 22.5562C7.43794 30.8026 13.9593 37.4877 22.0039 37.4877ZM22.0039 45.1123C34.1563 45.1123 44.0078 35.0136 44.0078 22.5562C44.0078 10.0987 34.1563 0 22.0039 0C9.85148 0 0 10.0987 0 22.5562C0 35.0136 9.85148 45.1123 22.0039 45.1123Z",
    fill: "url(#paint1_linear_1629_57)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1629_57",
    x1: 6.5407,
    y1: 22.3039,
    x2: 36.7853,
    y2: 22.3039,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#479DD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00B69C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1629_57",
    x1: -1.95933e-7,
    y1: 22.3035,
    x2: 44.1408,
    y2: 22.3035,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#479DD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00B69C"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoMobile);
export default __webpack_public_path__ + "static/media/logo_mobile.86eb12cb5c467a762dcbc337be5ab2c4.svg";
export { ForwardRef as ReactComponent };